module.exports = __webpack_public_path__ + "static/media/73.808e012c.jpg";